import React, { useState, useEffect, useCallback } from "react";
import { useSelector } from "react-redux";
import {
  Table,
  Typography,
  Tag,
  Select,
  Row,
  Col,
  Button,
  Rate,
  message,
} from "antd";

import { StarOutlined, SearchOutlined, SyncOutlined } from "@ant-design/icons";
import AdvancedSearchForm from "../../../common/SearchForm";
import FeedbackDetailDrawerModal from "./components/feedbackDetailDrawerModal";
import styles from "../../../common/Layout.module.scss";
import LikeIcon from "../../../assets/like.png";
import DislikeIcon from "../../../assets/dislike.png";

const { Title, Link } = Typography;
const { Option } = Select;
function Feedback(props) {
  const allHomeFeedbackRefresh = useSelector(
    (state) => state.vendorEquipmenReducer.allHomeFeedbackHomeMessage
  );

  const [descriptionModal, setDescriptionModal] = useState(false);
  const [currentColumn, setCurrentColumn] = useState([]);
  const [searchOption, setSearchOption] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);

  const renderData = useCallback(
    (currentPage) => {
      props.getAtmedHomeFeedBack(undefined, 20, currentPage);
    },
    [props.getAtmedHomeFeedBack]
  );

  useEffect(() => {
    renderData(currentPage);
  }, [renderData, currentPage]);

  const handleRefresh = () => {
    props.getAtmedHomeFeedBack(undefined, 20, currentPage);
    if (allHomeFeedbackRefresh && allHomeFeedbackRefresh) {
      message.success(allHomeFeedbackRefresh.message);
    }
  };
  const columns = [
    {
      title: "Service Name",
      key: "sid",
      dataIndex: "sid",
      render: (_, columnData) => (
        <>
          <p className="name">{columnData.service_name}</p>
          <p className="orderId">Session ID: {columnData.sid}</p>
          <div className="table-fc-email">Booking ID: {columnData.bid}</div>
          <Link>
            <div
              onClick={() => {
                setDescriptionModal(true);
                setCurrentColumn(columnData);
              }}
            >
              <div className="view-details">view details</div>
            </div>
          </Link>
        </>
      ),
    },
    {
      title: "Patient Name",
      key: "patient_name",
      dataIndex: "patient_name",
      render: (_, columnData) => (
        <Row>
          <Col span={24}>{columnData.patient_name} </Col>
          <Col span={24} className="lightFont">
            {columnData.patient_phone}
          </Col>
          <Col span={24} className="lightFont">
            {columnData.patient_age} / {columnData.patient_gender}
          </Col>
        </Row>
      ),
    },
    {
      title: "Reviews",
      key: "review",
      render: (_, columnData) => (
        <div>
          <div className="content f-Size-13px">{`${columnData.review}`}</div>
          {columnData.rating >= 4 ? (
            <>
              {columnData.professionalism > 0 ? (
                <Tag color="success" className={styles.feedbackReviewStyle}>
                  <img
                    src={LikeIcon}
                    alt="Professionalism"
                    className="thumbs-up"
                  />
                  Professionalism
                </Tag>
              ) : (
                ""
              )}

              {columnData.punctuality > 0 ? (
                <Tag color="success" className={styles.feedbackReviewStyle}>
                  <img src={LikeIcon} alt="Punctuality" className="thumbs-up" />
                  Punctuality
                </Tag>
              ) : (
                ""
              )}

              {columnData.service > 0 ? (
                <Tag color="success" className={styles.feedbackReviewStyle}>
                  <img src={LikeIcon} alt="Service" className="thumbs-up" />
                  Service
                </Tag>
              ) : (
                ""
              )}
            </>
          ) : (
            <>
              {columnData.professionalism > 0 ? (
                <Tag color="error" className={styles.feedbackReviewStyle}>
                  <img src={DislikeIcon} alt="Professionalism" />
                  Professionalism
                </Tag>
              ) : (
                ""
              )}
              {columnData.punctuality > 0 ? (
                <Tag color="error" className={styles.feedbackReviewStyle}>
                  <img src={DislikeIcon} alt="Punctuality" />
                  Punctuality
                </Tag>
              ) : (
                ""
              )}
              {columnData.service > 0 ? (
                <Tag color="error" className={styles.feedbackReviewStyle}>
                  <img src={DislikeIcon} alt="Service" />
                  Service
                </Tag>
              ) : (
                ""
              )}
            </>
          )}
        </div>
      ),
    },
    {
      title: "Ratings",
      key: "rating",
      render: (_, columnData) => <Rate disabled value={columnData.rating} />,
    },
  ];
  const onSearch = (values) => {
    const newValues = JSON.parse(JSON.stringify(values));
    const queryString = Object.keys(newValues)
      .map((key) => `${key}=${newValues[key]}`)
      .join("&");
    props.getAtmedHomeFeedBack(queryString, 20, currentPage);
  };

  const toggleSearch = () => {
    setSearchOption(!searchOption);
  };

  return (
    <div>
      <FeedbackDetailDrawerModal
        data={currentColumn}
        visible={descriptionModal}
        onCancel={() => setDescriptionModal(false)}
      />
      <Row gutter={[0, 16]}>
        <Col className="gutter-row section-heading" span={12} offset={0}>
          <Title
            level={2}
            className="d-flex"
            style={{ justifyContent: "space-between", alignItems: "center" }}
          >
            Feedback / Ratings
          </Title>
        </Col>
        <Col className="gutter-row" span={7} offset={0}></Col>
        <Col className="gutter-row" span={3} offset={0}>
          <Button
            className={`${
              searchOption === true ? "search-open" : "search-close"
            } search-toggle-button`}
            onClick={() => toggleSearch()}
          >
            <SearchOutlined /> Search
          </Button>
        </Col>
        <Col className="gutter-row" span={2} offset={0}>
          <Button
            shape="circle"
            icon={<SyncOutlined />}
            style={{ marginRight: 8, marginLeft: 10 }}
            onClick={() => handleRefresh()}
          />
        </Col>
      </Row>
      {searchOption === true ? (
        <AdvancedSearchForm
          onSearch={onSearch}
          onClose={() => setSearchOption(false)}
          title="Feedback / Ratings"
          columnWidth={{
            xs: 24,
            md: 12,
            lg: 8,
          }}
          formItems={[
            {
              key: "q[home_session_module_cont]",
              label: "Service Name",
            },
            {
              key: "q[home_session_sid_eq]",
              label: "Session ID",
            },
            {
              key: "q[patient_name_cont]",
              label: "Patient Name",
            },
            {
              key: "q[rating_eq]",
              label: "Ratings",
              Component: (
                <Select placeholder="Select Rating" size="large">
                  <Option value="5">
                    <StarOutlined />
                    <StarOutlined />
                    <StarOutlined />
                    <StarOutlined />
                    <StarOutlined />
                  </Option>
                  <Option value="4">
                    <StarOutlined />
                    <StarOutlined />
                    <StarOutlined />
                    <StarOutlined />
                  </Option>
                  <Option value="3">
                    <StarOutlined />
                    <StarOutlined />
                    <StarOutlined />
                  </Option>
                  <Option value="2">
                    <StarOutlined />
                    <StarOutlined />
                  </Option>
                  <Option value="1">
                    <StarOutlined />
                  </Option>
                </Select>
              ),
            },
          ]}
        />
      ) : (
        ""
      )}
      <Table
        className="list_table"
        dataSource={
          props.allHomeFeedbackHome ? props.allHomeFeedbackHome.data : null
        }
        pagination={{
          pageSize: 20,
          total: props.allHomeFeedbackHome?.total_count,
          showSizeChanger: false,
        }}
        columns={columns}
        scroll={{ x: 800 }}
        rowKey="sid"
        onChange={(e) => {
          setCurrentPage(e.current);
        }}
      />
    </div>
  );
}

export default Feedback;
